import { trackedContentName } from '../ProductSliderModule/trackedContentName';

export const inPageNavigationTracking = (moduleName: string, anchorId: string) =>
  `inpage-navi | ${trackedContentName(moduleName)} | | ${trackedContentName(anchorId)} | EVENT`;
